import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  constructor(private authService: AuthenticationService) {
  }

  transform(date: any, format: string = 'yyyy-MM-dd'): string {
    let selectedFormat = this.authService.currentUserValue ? this.authService.currentUserValue.user.dateFormat : format;
    if (selectedFormat.includes('mm')) {
      selectedFormat = selectedFormat.replace('mm', 'MM');
    }
    if (format.includes('h:mm a')) {
      selectedFormat += ' h:mm a';
    }
    return new DatePipe(localStorage.getItem('language') || 'en').transform(date, selectedFormat)!;
  }

}
// 19 Sep, 2023, 9:04 AM
